(() => {
  const initTabbedProductCarousel = () => {
    document.querySelectorAll('.tabbed-product-carousel_container__Ea4oS').forEach((section) => {
      const tabs = section.querySelectorAll('.tabbed-product-carousel_tab__d9wqz');
      const panels = section.querySelectorAll('.tabbed-product-carousel_panel__QbgFB');
      const titleWrapper = section.querySelector('.tabbed-product-carousel_textWrapper__2Vxq4');

      if (tabs.length === 0) return;
      
  
      const setupCustomAnimation = (swiperElement) => {
        // Store current mode
        swiperElement._previousIsMobile = window.innerWidth <= 900;
        if (!swiperElement) return;
        
        const isMobile = window.innerWidth <= 900;
        
        // On mobile, let Swiper handle centering naturally with padding
        if (isMobile) {
          const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
          if (!swiperWrapper) return;
          
          // Wait for Swiper to initialize
          const waitForSwiper = () => {
            if (swiperElement.swiper && swiperElement.swiper.initialized) {
              // Ensure centeredSlides is enabled
              if (swiperElement.swiper.params) {
                swiperElement.swiper.params.centeredSlides = true;
                // Add padding to allow scrolling to the left edge
                swiperElement.swiper.params.slidesOffsetBefore = 0;
                swiperElement.swiper.params.slidesOffsetAfter = 0;
              }
              swiperElement.swiper.updateSize();
              swiperElement.swiper.updateSlides();
            } else {
              setTimeout(waitForSwiper, 50);
            }
          };
          
          waitForSwiper();
          
          // Also reapply on resize recalculate position when screen size changes
          let resizeTimeout;
          const handleResize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
              const currentIsMobile = window.innerWidth <= 900;
              if (swiperElement.swiper && swiperElement.swiper.initialized) {
                // Update swiper size and slides
                swiperElement.swiper.updateSize();
                swiperElement.swiper.updateSlides();
                
                if (currentIsMobile) {
                  // On mobile, recalculate centered position
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      applyCenteredPosition();
                    });
                  });
                } else {
                  // On desktop, reset to position 0 and re-enable desktop behavior
                  const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
                  if (swiperWrapper) {
                    // Remove mobile-specific styles
                    swiperWrapper.style.removeProperty('transform');
                    swiperWrapper.style.removeProperty('transition');
                    
                    // Disable centeredSlides for desktop
                    if (swiperElement.swiper.params) {
                      swiperElement.swiper.params.centeredSlides = false;
                    }
                    
                    // Reset Swiper's translate
                    swiperElement.swiper.setTranslate(0);
                    swiperElement.swiper.slideTo(0, 0);
                    
                    // Re-enable desktop custom animation if it was set up
                  
                    requestAnimationFrame(() => {
                      requestAnimationFrame(() => {
                        // Restore original setTranslate if it was overridden
                        if (swiperElement._originalSetTranslate && swiperElement.swiper.setTranslate) {
                          swiperElement.swiper.setTranslate = swiperElement._originalSetTranslate;
                          delete swiperElement._originalSetTranslate;
                        }
                        
                        // Clear mobile-specific properties
                        delete swiperElement._mobileCenteredPosition;
                        if (swiperElement._mobileTransformObserver) {
                          swiperElement._mobileTransformObserver.disconnect();
                          delete swiperElement._mobileTransformObserver;
                        }
                        
                        // Check if custom animation was previously set up
                        if (swiperElement._slideDistance !== undefined) {
                          // Re-initialize custom animation for desktop
                          swiperElement._customPosition = 0;
                          swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                          swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
                        } else {
                          // If custom animation wasn't set up, re-run setupCustomAnimation to initialize desktop behavior
                          setTimeout(() => {
                            setupCustomAnimation(swiperElement);
                          }, 150);
                        }
                      });
                    });
                  }
                }
              }
            }, 100);
          };
          window.addEventListener('resize', handleResize);
          
          // Store the resize handler so we can clean it up if needed
          swiperElement._mobileResizeHandler = handleResize;
          
          // Override any setTranslate calls to prevent resets, but allow Swiper's touch scrolling
          if (swiperElement.swiper) {
            const originalSetTranslate = swiperElement.swiper.setTranslate;
            swiperElement.swiper.setTranslate = function(newTranslate) {
              // On mobile, allow normal Swiper scrolling without override
              // This allows users to scroll all the way to the left edge
              originalSetTranslate.call(this, newTranslate);
            };
          }
          
          return;
        }
        
        const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
        if (!swiperWrapper) {
          return;
        }
        
        // Disable Swiper's navigation (desktop only) but keep dragging enabled
        if (swiperElement.swiper) {
          if (swiperElement.swiper.navigation) {
            swiperElement.swiper.navigation.destroy();
          }
          // Keep allowTouchMove, allowSlideNext, and allowSlidePrev enabled for mouse dragging
          swiperElement.swiper.allowTouchMove = true;
          swiperElement.swiper.allowSlideNext = true;
          swiperElement.swiper.allowSlidePrev = true;
        }
        
        // Wait for buttons to be available
        const setupButtons = () => {
          const nextBtn = swiperElement.querySelector('.tabbed-carousel-nav-btn--next') || 
                         swiperElement.querySelector('.slider-nav__btn[name=next]') ||
                         swiperElement.querySelector('button[name=next]');
          const prevBtn = swiperElement.querySelector('.tabbed-carousel-nav-btn--prev') || 
                        swiperElement.querySelector('.slider-nav__btn[name=prev]') ||
                        swiperElement.querySelector('button[name=prev]');
          
          
          if (!nextBtn || !prevBtn) {
            // Try again after a short delay
            setTimeout(setupButtons, 100);
            return;
          }
          
          // Initialize position tracking
          if (swiperElement._customPosition === undefined) {
            swiperElement._customPosition = 0;
          }
          if (swiperElement._slideDistance === undefined) {
            swiperElement._slideDistance = 0;
          }
          
          // Calculate slide distance
          const calculateSlideDistance = () => {
            const slides = swiperWrapper.querySelectorAll('.swiper-slide');
            if (slides.length < 2) return 0;
            const firstSlide = slides[0];
            const secondSlide = slides[1];
            if (!firstSlide || !secondSlide) return 0;
            const firstRect = firstSlide.getBoundingClientRect();
            const secondRect = secondSlide.getBoundingClientRect();
            return secondRect.left - firstRect.left;
          };
          
          // Initialize
          const initCustomAnimation = () => {
            const isMobile = window.innerWidth <= 900;
            // On mobile, don't set up custom animation - let Swiper handle centering
            if (isMobile) {
              // Just add fade-in class after products have time to load
              setTimeout(() => {
                swiperElement.classList.add('fade-in');
                // Remove inline opacity to let CSS handle it
                swiperElement.style.opacity = '';
              }, 250);
              return;
            }
            
            // Desktop: Set up custom animation
            swiperElement._slideDistance = calculateSlideDistance();
            swiperElement._customPosition = 0;
            swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
            swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
            // Update button states after initialization
            setTimeout(updateButtonStates, 100);
            // Add fade-in class back to show products after products have time to load
            setTimeout(() => {
              swiperElement.classList.add('fade-in');
              // Remove inline opacity to let CSS handle it
              swiperElement.style.opacity = '';
            }, 250);
          };
          
          // Update button states
          const updateButtonStates = () => {
            const currentNextBtn = swiperElement.querySelector('.tabbed-carousel-nav-btn--next') || 
                                   swiperElement.querySelector('.slider-nav__btn[name=next]') ||
                                   swiperElement.querySelector('button[name=next]');
            const currentPrevBtn = swiperElement.querySelector('.tabbed-carousel-nav-btn--prev') || 
                                  swiperElement.querySelector('.slider-nav__btn[name=prev]') ||
                                  swiperElement.querySelector('button[name=prev]');
            
            if (!currentNextBtn || !currentPrevBtn) return;
            
            const slides = swiperWrapper.querySelectorAll('.swiper-slide');
            const totalSlides = slides.length;
            const container = swiperElement.querySelector('.swiper');
            
            if (!container || swiperElement._slideDistance === 0) {
              // Enable both if we can't calculate
              currentPrevBtn.removeAttribute('disabled');
              currentPrevBtn.style.opacity = '1';
              currentNextBtn.removeAttribute('disabled');
              currentNextBtn.style.opacity = '1';
              return;
            }
            
            const containerWidth = container.clientWidth;
            const visibleSlides = Math.floor(containerWidth / swiperElement._slideDistance) || 1;
            const maxScroll = (totalSlides - visibleSlides) * swiperElement._slideDistance;
            
            // Can go left if position is negative
            const canGoLeft = swiperElement._customPosition < 0;
            // Can go right if not at max position
            const canGoRight = Math.abs(swiperElement._customPosition) < maxScroll;
            
            // Update prev button
            if (canGoLeft) {
              currentPrevBtn.removeAttribute('disabled');
              currentPrevBtn.disabled = false;
              currentPrevBtn.style.opacity = '1';
              currentPrevBtn.style.cursor = 'pointer';
              currentPrevBtn.style.pointerEvents = 'auto';
            } else {
              currentPrevBtn.setAttribute('disabled', 'disabled');
              currentPrevBtn.disabled = true;
              currentPrevBtn.style.opacity = '0.3';
              currentPrevBtn.style.cursor = 'not-allowed';
              currentPrevBtn.style.pointerEvents = 'none';
            }
            
            // Update next button
            if (canGoRight) {
              currentNextBtn.removeAttribute('disabled');
              currentNextBtn.disabled = false;
              currentNextBtn.style.opacity = '1';
              currentNextBtn.style.cursor = 'pointer';
              currentNextBtn.style.pointerEvents = 'auto';
            } else {
              currentNextBtn.setAttribute('disabled', 'disabled');
              currentNextBtn.disabled = true;
              currentNextBtn.style.opacity = '0.3';
              currentNextBtn.style.cursor = 'not-allowed';
              currentNextBtn.style.pointerEvents = 'none';
            }
          };
          
          // Next handler
          const handleNext = (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            if (swiperElement._slideDistance === 0) {
              swiperElement._slideDistance = calculateSlideDistance();
            }
            if (swiperElement._slideDistance === 0) return;
            
            const slides = swiperWrapper.querySelectorAll('.swiper-slide');
            const totalSlides = slides.length;
            const container = swiperElement.querySelector('.swiper');
            if (!container) return;
            
            const containerWidth = container.clientWidth;
            const visibleSlides = Math.floor(containerWidth / swiperElement._slideDistance) || 1;
            const maxPosition = -(totalSlides - visibleSlides) * swiperElement._slideDistance;
            
            if (swiperElement._customPosition <= maxPosition) {
              updateButtonStates();
              return;
            }
            
            swiperElement._customPosition -= swiperElement._slideDistance;
            
            swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
            swiperWrapper.style.transform = `translate3d(${swiperElement._customPosition}px, 0px, 0px)`;
            
            // Update button states immediately
            updateButtonStates();
          };
          
          // Prev handler
          const handlePrev = (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            if (swiperElement._slideDistance === 0) {
              swiperElement._slideDistance = calculateSlideDistance();
            }
            if (swiperElement._slideDistance === 0) return;
            if (swiperElement._customPosition >= 0) {
              updateButtonStates();
              return;
            }
            
            swiperElement._customPosition += swiperElement._slideDistance;
            
            swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
            swiperWrapper.style.transform = `translate3d(${swiperElement._customPosition}px, 0px, 0px)`;
            
            // Update button states immediately
            updateButtonStates();
          };
          
          // Remove old handlers and attach new ones
          const newNextBtn = nextBtn.cloneNode(true);
          nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
          const newPrevBtn = prevBtn.cloneNode(true);
          prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
          
          newNextBtn.onclick = handleNext;
          newPrevBtn.onclick = handlePrev;
          newNextBtn.addEventListener('click', handleNext, true);
          newPrevBtn.addEventListener('click', handlePrev, true);
          
          
          // Initialize after layout
          setTimeout(() => {
            initCustomAnimation();
            // Ensure fade-in is added after initialization and products have loaded
            setTimeout(() => {
              swiperElement.classList.add('fade-in');
              // Remove inline opacity to let CSS handle it
              swiperElement.style.opacity = '';
            }, 250);
          }, 150);
        };
        
        // Start setting up buttons
        setTimeout(setupButtons, 200);
      };
      
      // Store setupCustomAnimation on section for access from global resize handler
      section._setupCustomAnimation = setupCustomAnimation;

      // Function to update selected tab indicator
      const updateSelectedTabIndicator = (activeTab) => {
        const indicator = section.querySelector('.tabbed-product-carousel_selectedTab__P5f9M');
        const tabListContainer = section.querySelector('.tabbed-product-carousel_tabListContainer__B265N');
        
        if (indicator && tabListContainer && activeTab) {
          // Get gradient colors from data attributes
          let gradientStart = activeTab.getAttribute('data-gradient-start');
          let gradientEnd = activeTab.getAttribute('data-gradient-end');
          
          // Normalize values
          gradientStart = gradientStart ? gradientStart.trim() : '';
          gradientEnd = gradientEnd ? gradientEnd.trim() : '';
          
          // Fallback to defaults if nothing is set
          if (!gradientStart) gradientStart = '#3C39D7';
          if (!gradientEnd) gradientEnd = '#07ACD0';
          
          const gradient = `linear-gradient(90deg, ${gradientStart}, ${gradientEnd})`;
          
          // Wait for layout to complete
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const tabRect = activeTab.getBoundingClientRect();
              const containerRect = tabListContainer.getBoundingClientRect();
              
              // Calculate position: tab's viewport position - container's viewport position + scroll offset
              // This gives us the tab's position relative to the container's content area
              const scrollLeft = tabListContainer.scrollLeft || 0;
              const left = (tabRect.left - containerRect.left) + scrollLeft;
              const top = tabRect.top - containerRect.top;
              
              // Remove any CSS variable references first
              indicator.style.removeProperty('--tab-gradient');
              
              // Update indicator position and style - directly set background
              indicator.style.background = gradient;
              indicator.style.backgroundImage = gradient;
              indicator.style.width = `${tabRect.width}px`;
              indicator.style.height = `${tabRect.height}px`;
              indicator.style.transform = `translate(${left}px, ${top}px)`;
              indicator.style.opacity = '1';
              
              // Force a reflow to ensure the style is applied
              void indicator.offsetHeight;
              
            });
          });
        }
      };
      
      // Store the function on the section so it can be accessed from global resize handler
      section._updateSelectedTabIndicator = updateSelectedTabIndicator;
      
      // Listen for scroll events on the tab container to update indicator position
      const tabListContainer = section.querySelector('.tabbed-product-carousel_tabListContainer__B265N');
      if (tabListContainer) {
        let scrollTimeout;
        const handleTabScroll = () => {
          // Debounce scroll events
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            const activeTab = section.querySelector('.tabbed-product-carousel_tab__d9wqz.tabbed-product-carousel_tab--active');
            if (activeTab) {
              updateSelectedTabIndicator(activeTab);
            }
          }, 10);
        };
        
        tabListContainer.addEventListener('scroll', handleTabScroll, { passive: true });
        
        // Store handler for cleanup if needed
        tabListContainer._tabScrollHandler = handleTabScroll;
      }


      // Function to update background image with fade transition
      const updateBackgroundImage = (activeTab) => {
        const backgroundContainer = section.querySelector('.tabbed-product-carousel-background_background__xrm3u');
        if (!backgroundContainer) return;

        const backgroundImageUrl = activeTab?.getAttribute('data-background-image');
        const backgroundImageId = activeTab?.getAttribute('data-background-image-id');
        const existingImage = backgroundContainer.querySelector('.tabbed-product-carousel-background_backgroundImage__t0luL');

        if (backgroundImageUrl && backgroundImageId) {
          // Check if image already exists with the same ID
          if (existingImage && existingImage.getAttribute('data-background-image-id') === backgroundImageId) {
            // Image already displayed, no transition needed
            existingImage.style.display = 'block';
            existingImage.style.opacity = '1';
          } else {
            // Fade out existing image if it exists
            if (existingImage) {
              existingImage.style.opacity = '0';
              // Remove old image after fade out completes
              setTimeout(() => {
                if (existingImage.parentNode) {
                  existingImage.remove();
                }
              }, 600); // Match CSS transition duration
            }

            // Create new image element
            const img = document.createElement('img');
            img.src = backgroundImageUrl;
            // Use the URL as srcset for simplicity (browser will handle responsive loading)
            img.srcset = backgroundImageUrl;
            img.sizes = '100vw';
            img.alt = '';
            img.className = 'tabbed-product-carousel-background_backgroundImage__t0luL';
            img.setAttribute('aria-hidden', 'true');
            img.setAttribute('loading', 'lazy');
            img.setAttribute('data-background-image-id', backgroundImageId);
            img.setAttribute('data-fade-enabled', 'true'); // Enable fade transitions
            
            // Start with opacity 0 for fade-in
            img.style.opacity = '0';
            img.style.display = 'block';
            backgroundContainer.appendChild(img);
            
            // Trigger fade-in after a brief delay to ensure image is in DOM
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                img.style.opacity = '1';
              });
            });
          }
        } else if (existingImage) {
          // No background image for this tab, fade out existing image
          existingImage.style.opacity = '0';
          setTimeout(() => {
            if (existingImage.parentNode) {
              existingImage.style.display = 'none';
            }
          }, 600); // Match CSS transition duration
        }
      };

      // Function to update title
      const updateTitle = (title) => {
        const titleElement = section.querySelector('.tabbed-product-carousel_title__695p9');
        if (titleElement && title) {
          titleElement.innerHTML = `<span>${title}</span>`;
          if (titleWrapper) {
            titleWrapper.style.opacity = '1';
          }
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const tabIndex = parseInt(tab.getAttribute('data-tab-index'), 10);
          const panelId = tab.getAttribute('aria-controls');
          const tabTitle = tab.querySelector('span span')?.textContent || '';
          
          // Get title from the panel or use tab title
          const panel = section.querySelector(`#${CSS.escape(panelId)}`);
          const panelTitle = panel?.getAttribute('data-title') || tabTitle;

          // Update all tabs
          section.querySelectorAll('.tabbed-product-carousel_tab__d9wqz').forEach((t) => {
            const isSameIndex = parseInt(t.getAttribute('data-tab-index'), 10) === tabIndex;
            const tabTitleSpan = t.querySelector('span');
            
            if (isSameIndex) {
              t.classList.add('tabbed-product-carousel_tab--active');
              t.setAttribute('aria-selected', 'true');
              t.setAttribute('tabindex', '0');
              
              // Update tab title styling
              if (tabTitleSpan) {
                tabTitleSpan.classList.remove('tabbed-product-carousel_tabTitle__mYZJ2');
                tabTitleSpan.classList.add('tabbed-product-carousel_tabTitleSelected__ldJue');
              }
              
              // Update selected tab indicator
              requestAnimationFrame(() => {
                updateSelectedTabIndicator(t);
              });
            } else {
              t.classList.remove('tabbed-product-carousel_tab--active');
              t.setAttribute('aria-selected', 'false');
              t.setAttribute('tabindex', '-1');
              
              // Update tab title styling
              if (tabTitleSpan) {
                tabTitleSpan.classList.remove('tabbed-product-carousel_tabTitleSelected__ldJue');
                tabTitleSpan.classList.add('tabbed-product-carousel_tabTitle__mYZJ2');
              }
            }
          });

          // Update all panels
          section.querySelectorAll('.tabbed-product-carousel_panel__QbgFB').forEach((panel) => {
            if (panel.id === panelId) {
              // Show and activate panel
              panel.removeAttribute('hidden');
              panel.offsetHeight; // Force reflow
              
              // Initialize Swiper for this panel if not already initialized
              const swiperElement = panel.querySelector('product-swiper');
              
              // Remove fade-in class initially to hide products and ensure smooth fade-out
              if (swiperElement) {
                // Add a small delay to allow fade-out before removing class
                swiperElement.style.opacity = '0';
                swiperElement.classList.remove('fade-in');
                // Set up custom animation for this swiper
                setupCustomAnimation(swiperElement);
              }
              
              requestAnimationFrame(() => {
                panel.classList.add('tabbed-product-carousel_panel--active');
              });
              
              if (swiperElement) {
                // Function to check if panel is visible
                const isPanelVisible = () => {
                  const style = window.getComputedStyle(panel);
                  return style.display !== 'none' && 
                         style.visibility !== 'hidden' && 
                         !panel.hasAttribute('hidden') &&
                         panel.classList.contains('tabbed-product-carousel_panel--active');
                };

                // Function to reset swiper to first slide
                const resetSwiper = () => {
                  
                  if (!isPanelVisible()) {
                    // Panel not visible yet, try again
                    setTimeout(resetSwiper, 50);
                    return;
                  }

                  const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
                  const isMobile = window.innerWidth <= 900;
                  
                  // Reset custom animation position - disable transition temporarily for instant reset
                  if (swiperWrapper) {
                    // Disable transition for instant position reset
                    swiperWrapper.style.transition = 'none';
                    // On mobile, don't force to 0px - let Swiper center it
                    // On desktop, reset to 0px
                    if (!isMobile) {
                      swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
                    }
                    // Reset stored position
                    if (swiperElement._customPosition !== undefined) {
                      swiperElement._customPosition = 0;
                    }
                  }

                  if (swiperElement.swiper && swiperElement.swiper.initialized && !swiperElement.swiper.destroyed) {
                    try {
                      // On desktop, set initial position but don't block animations
                      // On mobile, let Swiper calculate the centered position
                      if (swiperWrapper && !isMobile) {
                        // Set initial position without animation
                        swiperElement.swiper.setTranslate(0);
                      } else if (isMobile) {
                        // On mobile, ensure centeredSlides is enabled and let Swiper center
                        if (swiperElement.swiper.params) {
                          swiperElement.swiper.params.centeredSlides = true;
                        }
                        // Update and let Swiper calculate centered position
                        swiperElement.swiper.updateSize();
                        swiperElement.swiper.updateSlides();
                        // Slide to first slide with centering - instant (speed 0)
                        swiperElement.swiper.slideTo(0, 0);
                      }
                      
                      // Re-enable transition after a brief moment for future animations
                      if (swiperWrapper) {
                        requestAnimationFrame(() => {
                          requestAnimationFrame(() => {
                            if (!isMobile) {
                              swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                            }
                          });
                        });
                      }
                      
                      // Wait for panel to be fully laid out
                      const swiperContainer = swiperElement.querySelector('.swiper');
                      if (swiperContainer) {
                        swiperContainer.offsetHeight; // Force reflow
                      }
                      
                      // Wait for panel to be fully laid out and visible
                      setTimeout(() => {
                        // Check if we're on mobile (up to 900px)
                        const isMobile = window.innerWidth <= 900;
                        
                        // On mobile, keep centeredSlides enabled to show centered like on refresh
                        // On desktop, disable it to start at 0px
                        if (!isMobile && swiperElement.swiper.params && swiperElement.swiper.params.centeredSlides) {
                          swiperElement.swiper.params.centeredSlides = false;
                        } else if (isMobile && swiperElement.swiper.params && !swiperElement.swiper.params.centeredSlides) {
                          swiperElement.swiper.params.centeredSlides = true;
                        }
                        
                        // Update swiper size and slides ONCE after panel is visible
                        swiperElement.swiper.updateSize();
                        swiperElement.swiper.updateSlides();
                        
                        // On mobile, ensure the slide is centered after update
                        if (isMobile && swiperElement.swiper.params.centeredSlides) {
                          // Temporarily disable transition for instant reset
                          if (swiperWrapper) {
                            swiperWrapper.style.transition = 'none';
                          }
                          // Force Swiper to recalculate and center - instant (speed 0)
                          swiperElement.swiper.slideTo(0, 0);
                          // Allow Swiper to update the transform for centering
                          swiperElement.swiper.update();
                          // Re-enable transition after reset
                          requestAnimationFrame(() => {
                            if (swiperWrapper) {
                              swiperWrapper.style.transition = '';
                            }
                          });
                        }
                        
                        // Disable Swiper's navigation and prevent it from controlling transforms
                        // BUT on mobile, we need to allow Swiper to maintain centering
                        if (swiperElement.swiper) {
                          if (swiperElement.swiper.navigation) {
                            swiperElement.swiper.navigation.destroy();
                          }
                          // On mobile, keep Swiper's transform control enabled for centering
                          // On desktop, keep dragging enabled but allow custom animation for buttons
                          if (!isMobile) {
                            // Keep Swiper's dragging enabled for mouse drag
                            swiperElement.swiper.allowTouchMove = true;
                            swiperElement.swiper.allowSlideNext = true;
                            swiperElement.swiper.allowSlidePrev = true;
                          }
                        }
                        
                        // Wait a bit for everything to settle, then set up custom animation
                        // BUT only on desktop - on mobile, let Swiper handle everything
                        setTimeout(() => {
                          // On mobile, don't set up custom animation - let Swiper handle centering
                          if (isMobile) {
                            // Temporarily disable transition for instant reset
                            if (swiperWrapper) {
                              swiperWrapper.style.transition = 'none';
                            }
                            // Just ensure Swiper is properly centered and can control transforms
                            if (swiperElement.swiper && swiperElement.swiper.params.centeredSlides) {
                              swiperElement.swiper.update();
                              swiperElement.swiper.slideTo(0, 0);
                            }
                            // Re-enable transition after reset
                            requestAnimationFrame(() => {
                              if (swiperWrapper) {
                                swiperWrapper.style.transition = '';
                              }
                            });
                            return;
                          }
                          
                          // Desktop: Set up custom animation
                          // Try multiple selectors to find buttons
                          const nextBtn = swiperElement.querySelector('.tabbed-carousel-nav-btn--next') || 
                                         swiperElement.querySelector('.slider-nav__btn[name=next]') ||
                                         swiperElement.querySelector('button[name=next]');
                          const prevBtn = swiperElement.querySelector('.tabbed-carousel-nav-btn--prev') || 
                                        swiperElement.querySelector('.slider-nav__btn[name=prev]') ||
                                        swiperElement.querySelector('button[name=prev]');
                          
                          if (!nextBtn || !prevBtn || !swiperWrapper) {
                            return;
                          }
                          
                          // Store position on the swiper element so it persists
                          if (swiperElement._customPosition === undefined) {
                            swiperElement._customPosition = 0;
                          }
                          if (swiperElement._slideDistance === undefined) {
                            swiperElement._slideDistance = 0;
                          }
                          
                          // Calculate slide distance (slide width + gap)
                          const calculateSlideDistance = () => {
                            const slides = swiperWrapper.querySelectorAll('.swiper-slide');
                            if (slides.length < 2) return 0;
                            
                            const firstSlide = slides[0];
                            const secondSlide = slides[1];
                            
                            if (!firstSlide || !secondSlide) return 0;
                            
                            const firstRect = firstSlide.getBoundingClientRect();
                            const secondRect = secondSlide.getBoundingClientRect();
                            
                            // Distance between leading edges of adjacent slides
                            const distance = secondRect.left - firstRect.left;
                            return distance;
                          };
                          
                          // Initialize animation
                          const initCustomAnimation = () => {
                            const isMobile = window.innerWidth <= 900;
                            // On mobile, don't set transform - let Swiper center
                            if (isMobile) {
                              return;
                            }
                            
                            swiperElement._slideDistance = calculateSlideDistance();
                            swiperElement._customPosition = 0;
                            
                            // Ensure Swiper allows touch/mouse movement for dragging
                            if (swiperElement.swiper) {
                              swiperElement.swiper.allowTouchMove = true;
                              // Let Swiper control the transform - don't set it manually
                              swiperElement.swiper.slideTo(0, 0);
                            } else {
                              // Fallback if Swiper not ready
                              swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                              swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
                            }
                            
                            // Don't override Swiper's setTranslate - let it handle mouse dragging
                            // The custom animation will work for button clicks, but Swiper handles dragging
                            
                            // Add fade-in class back to show products after products have time to load
                            setTimeout(() => {
                              swiperElement.classList.add('fade-in');
                              // Remove inline opacity to let CSS handle it
                              swiperElement.style.opacity = '';
                            }, 250);
                          };
                          
                          // Custom next handler
                          const handleNext = (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            
                            
                            if (swiperElement._slideDistance === 0) {
                              swiperElement._slideDistance = calculateSlideDistance();
                            }
                            
                            if (swiperElement._slideDistance === 0) {
                              return;
                            }
                            
                            const slides = swiperWrapper.querySelectorAll('.swiper-slide');
                            const totalSlides = slides.length;
                            const container = swiperElement.querySelector('.swiper');
                            if (!container) return;
                            
                            const containerWidth = container.clientWidth;
                            const visibleSlides = Math.floor(containerWidth / swiperElement._slideDistance) || 1;
                            
                            // Check if we can go right
                            const maxPosition = -(totalSlides - visibleSlides) * swiperElement._slideDistance;
                            if (swiperElement._customPosition <= maxPosition) {
                              return;
                            }
                            
                            // Move right (negative direction)
                            swiperElement._customPosition -= swiperElement._slideDistance;
                            
                            // Use Swiper's slideTo instead of manual transform to allow mouse dragging
                            if (swiperElement.swiper) {
                              // Calculate which slide index to go to
                              const currentIndex = swiperElement.swiper.activeIndex;
                              const nextIndex = Math.min(currentIndex + 1, totalSlides - visibleSlides);
                              swiperElement.swiper.slideTo(nextIndex, 600);
                            } else {
                              // Fallback to manual transform if Swiper not available
                              swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                              swiperWrapper.style.transform = `translate3d(${swiperElement._customPosition}px, 0px, 0px)`;
                            }
                            
                            // Ensure Swiper allows touch/mouse movement for dragging
                            if (swiperElement.swiper) {
                              swiperElement.swiper.allowTouchMove = true;
                            }
                          };
                          
                          // Custom prev handler
                          const handlePrev = (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            
                            
                            if (swiperElement._slideDistance === 0) {
                              swiperElement._slideDistance = calculateSlideDistance();
                            }
                            
                            if (swiperElement._slideDistance === 0) {
                              return;
                            }
                            
                            // Check if we can go left (back to start)
                            if (swiperElement._customPosition >= 0) {
                              return;
                            }
                            
                            // Move left (positive direction)
                            swiperElement._customPosition += swiperElement._slideDistance;
                            
                            // Use Swiper's slideTo instead of manual transform to allow mouse dragging
                            if (swiperElement.swiper) {
                              // Calculate which slide index to go to
                              const currentIndex = swiperElement.swiper.activeIndex;
                              const prevIndex = Math.max(currentIndex - 1, 0);
                              swiperElement.swiper.slideTo(prevIndex, 600);
                            } else {
                              // Fallback to manual transform if Swiper not available
                              swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                              swiperWrapper.style.transform = `translate3d(${swiperElement._customPosition}px, 0px, 0px)`;
                            }
                            
                            // Ensure Swiper allows touch/mouse movement for dragging
                            if (swiperElement.swiper) {
                              swiperElement.swiper.allowTouchMove = true;
                            }
                          };
                          
                          // Remove existing handlers and attach new ones
                          const newNextBtn = nextBtn.cloneNode(true);
                          nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
                          const newPrevBtn = prevBtn.cloneNode(true);
                          prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
                          
                          // Attach handlers with high priority - use onclick for maximum compatibility
                          newNextBtn.onclick = handleNext;
                          newPrevBtn.onclick = handlePrev;
                          newNextBtn.addEventListener('click', handleNext, true);
                          newPrevBtn.addEventListener('click', handlePrev, true);
                          
                          // Initialize after layout
                          setTimeout(initCustomAnimation, 150);
                          
                          // Sync custom position with Swiper's position when dragging
                          if (swiperElement.swiper) {
                            swiperElement.swiper.on('touchMove', () => {
                              if (swiperElement.swiper && swiperElement.swiper.getTranslate) {
                                const translate = swiperElement.swiper.getTranslate();
                                swiperElement._customPosition = translate;
                              }
                            });
                            
                            swiperElement.swiper.on('slideChange', () => {
                              if (swiperElement.swiper && swiperElement.swiper.getTranslate) {
                                const translate = swiperElement.swiper.getTranslate();
                                swiperElement._customPosition = translate;
                              }
                            });
                          }
                          
                          // Recalculate on resize
                          let resizeTimeout;
                          const resizeHandler = () => {
                            clearTimeout(resizeTimeout);
                            resizeTimeout = setTimeout(() => {
                              swiperElement._slideDistance = calculateSlideDistance();
                              swiperElement._customPosition = 0;
                              swiperWrapper.style.setProperty('transform', 'translate3d(0px, 0px, 0px)', 'important');
                            }, 250);
                          };
                          window.addEventListener('resize', resizeHandler);
                        }, 200);
                        
                        // If loop mode is enabled, we need to recreate the loop to ensure correct positioning
                        if (swiperElement.swiper.params && swiperElement.swiper.params.loop) {
                          // Destroy and recreate loop to ensure clean state
                          swiperElement.swiper.loopDestroy();
                          swiperElement.swiper.loopCreate();
                        }
                        
                        // Wait for loop to be recreated and size update to complete
                        requestAnimationFrame(() => {
                         
                          // On mobile, don't reset - let Swiper center
                          if (swiperWrapper && !isMobile) {
                            // Disable transition for instant reset
                            swiperWrapper.style.transition = 'none';
                            swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
                            
                            // Reset position tracking
                            if (typeof currentPosition !== 'undefined') {
                              currentPosition = 0;
                            }
                          }
                          
                          // Now navigate to the first slide with no animation for initial reset only
                          if (swiperElement.swiper.params && swiperElement.swiper.params.loop) {
                            swiperElement.swiper.slideToLoop(0, 0, false);
                          } else {
                            swiperElement.swiper.slideTo(0, 0, false);
                          }
                          
                          // On desktop,  translate stays at 0px initially
                          // On mobile,  Swiper calculate the centered position
                          requestAnimationFrame(() => {
                            if (!isMobile && swiperWrapper) {
                              swiperElement.swiper.setTranslate(0);
                              // Re-enable transition after instant reset
                              requestAnimationFrame(() => {
                                swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                              });
                            } else if (isMobile) {
                              // Temporarily disable transition for instant reset
                              if (swiperWrapper) {
                                swiperWrapper.style.transition = 'none';
                              }
                              // On mobile, ensure Swiper centers the slide
                              if (swiperElement.swiper.params && swiperElement.swiper.params.centeredSlides) {
                                swiperElement.swiper.update();
                                // Force Swiper to recalculate centered position 
                                swiperElement.swiper.slideTo(0, 0);
                              }
                              // Re-enable transition after reset
                              requestAnimationFrame(() => {
                                if (swiperWrapper) {
                                  swiperWrapper.style.transition = '';
                                }
                              });
                            }
                            
                            // Final update to ensure everything is in sync
                            swiperElement.swiper.update();
                            
                            //  fade in the products after swiper is ready and products have loaded
                            setTimeout(() => {
                              swiperElement.classList.add('fade-in');
                              // Remove inline opacity to let CSS handle it
                              swiperElement.style.opacity = '';
                            }, 250);
                          });
                        });
                      }, 100); 
                    } catch (e) {
                    }
                  }
                };

                if (!swiperElement.hasAttribute('data-initialized')) {
                  swiperElement.setAttribute('data-initialized', 'true');
                  // Wait for swiper to initialize, then reset to first slide
                  let attempts = 0;
                  const maxAttempts = 60; 
                  const checkSwiper = setInterval(() => {
                    attempts++;
                    if (swiperElement.swiper && swiperElement.swiper.initialized) {
                      // Wait for panel to be fully visible and loop to be set up
                      setTimeout(() => {
                        resetSwiper();
                      }, 300);
                      clearInterval(checkSwiper);
                    } else if (attempts >= maxAttempts) {
                      clearInterval(checkSwiper);
                      // Fade in even if swiper didn't initialize
                      swiperElement.classList.add('fade-in');
                    }
                  }, 50);
                } else {
                  // Reset when panel becomes visible
                  // Wait for panel transition to complete, then reset
                  setTimeout(() => {
                    resetSwiper();
                  }, 300);
                }
              }
            } else {
              // Hide and deactivate panel
              panel.classList.remove('tabbed-product-carousel_panel--active');
              // Remove fade-in class when hiding and fade out smoothly
              const swiperElement = panel.querySelector('product-swiper');
              if (swiperElement) {
                // Fade out before removing class
                swiperElement.style.opacity = '0';
                setTimeout(() => {
                  swiperElement.classList.remove('fade-in');
                }, 100);
              }
              // Reset swiper in hidden panel to prevent position issues
              if (swiperElement && swiperElement.swiper && swiperElement.swiper.initialized) {
                try {
                  // Disable transition for instant reset when hiding
                  const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
                  if (swiperWrapper) {
                    swiperWrapper.style.transition = 'none';
                  }
                  // Reset to first slide before hiding - instant
                  if (swiperElement.swiper.params && swiperElement.swiper.params.loop) {
                    swiperElement.swiper.slideToLoop(0, 0, false);
                  } else {
                    swiperElement.swiper.slideTo(0, 0, false);
                  }
                  // Re-enable transition after reset
                  requestAnimationFrame(() => {
                    if (swiperWrapper) {
                      swiperWrapper.style.transition = '';
                    }
                  });
                } catch (e) {
                  // Ignore errors when hiding
                }
              }
              setTimeout(() => {
                if (!panel.classList.contains('tabbed-product-carousel_panel--active')) {
                  panel.setAttribute('hidden', '');
                }
              }, 300);
            }
          });

          // Update background image if available
          updateBackgroundImage(tab);
          
          // Update title
          updateTitle(panelTitle);
          
          // Update selected tab indicator position
          // Use double requestAnimationFrame to ensure layout is stable
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              updateSelectedTabIndicator(tab);
            });
          });
        });

        // Handle keyboard navigation
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const currentIndex = parseInt(tab.getAttribute('data-tab-index'), 10);
            let nextIndex;
            
            if (e.key === 'ArrowRight') {
              nextIndex = (currentIndex + 1) % tabs.length;
            } else {
              nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            }
            
            const nextTab = Array.from(tabs).find(t => 
              parseInt(t.getAttribute('data-tab-index'), 10) === nextIndex
            );
            
            if (nextTab) {
              nextTab.focus();
              nextTab.click();
            }
          }
        });
      });

      // Initialize first tab
      const firstTab = tabs[0];
      if (firstTab) {
        // Initialize background image for first tab 
        const backgroundContainer = section.querySelector('.tabbed-product-carousel-background_background__xrm3u');
        if (backgroundContainer) {
          const existingImage = backgroundContainer.querySelector('.tabbed-product-carousel-background_backgroundImage__t0luL');
          if (existingImage) {
            // Mark that fade transitions are now enabled for future changes
            existingImage.setAttribute('data-fade-enabled', 'true');
          }
        }
        // Initialize the selected tab indicator with first tab's gradient
        setTimeout(() => {
          updateSelectedTabIndicator(firstTab);
        }, 100);
        
        // Reset and fade in the first panel's products after a short delay
        const firstPanel = section.querySelector('.tabbed-product-carousel_panel__QbgFB.tabbed-product-carousel_panel--active');
        if (firstPanel) {
          const firstSwiper = firstPanel.querySelector('product-swiper');
          if (firstSwiper) {
            // Set up custom animation for first swiper
            setupCustomAnimation(firstSwiper);
            // Wait for swiper to initialize, then reset to position 0 and fade in
            let attempts = 0;
            const checkFirstSwiper = setInterval(() => {
              attempts++;
                  if (firstSwiper.swiper && firstSwiper.swiper.initialized) {
                    // Reset swiper to position 0
                    try {
                      const swiperWrapper = firstSwiper.querySelector('.swiper-wrapper');
                      const isMobile = window.innerWidth <= 900;
                      
                      if (!isMobile) {
                        // Disable centeredSlides for this section on desktop
                        if (firstSwiper.swiper.params.centeredSlides) {
                          firstSwiper.swiper.params.centeredSlides = false;
                          firstSwiper.swiper.update();
                        }
                        
                        // Disable transition for instant reset
                        if (swiperWrapper) {
                          swiperWrapper.style.transition = 'none';
                        }
                        
                        // Set initial position without blocking future animations
                        firstSwiper.swiper.setTranslate(0);
                        
                        // Navigate to first slide WITHOUT animation for initial reset (desktop only)
                        if (firstSwiper.swiper.params && firstSwiper.swiper.params.loop) {
                          firstSwiper.swiper.slideToLoop(0, 0, false);
                        } else {
                          firstSwiper.swiper.slideTo(0, 0, false);
                        }
                        
                        // Re-enable transition after instant reset
                        requestAnimationFrame(() => {
                          if (swiperWrapper) {
                            swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                          }
                        });
                      } else {
                        // On mobile, ensure centeredSlides is enabled and let Swiper center
                        if (firstSwiper.swiper.params && !firstSwiper.swiper.params.centeredSlides) {
                          firstSwiper.swiper.params.centeredSlides = true;
                        }
                        // Disable transition for instant reset
                        if (swiperWrapper) {
                          swiperWrapper.style.transition = 'none';
                        }
                        // Update Swiper to recalculate centered position
                        firstSwiper.swiper.updateSize();
                        firstSwiper.swiper.updateSlides();
                        // let Swiper's initial centering work
                        // Just update to force recalculation
                        firstSwiper.swiper.update();
                        // Re-enable transition after reset
                        requestAnimationFrame(() => {
                          if (swiperWrapper) {
                            swiperWrapper.style.transition = '';
                          }
                        });
                      }
                      
                      // Custom slide animation for first swiper (same as above)
                      const firstWrapper = firstSwiper.querySelector('.swiper-wrapper');
                      const firstNextBtn = firstSwiper.querySelector('.tabbed-carousel-nav-btn--next, .slider-nav__btn[name=next]');
                      const firstPrevBtn = firstSwiper.querySelector('.tabbed-carousel-nav-btn--prev, .slider-nav__btn[name=prev]');
                      
                      if (firstNextBtn && firstPrevBtn && firstWrapper) {
                        let firstCurrentPosition = 0;
                        let firstSlideDistance = 0;
                        
                        const calculateFirstSlideDistance = () => {
                          const slides = firstWrapper.querySelectorAll('.swiper-slide');
                          if (slides.length < 2) return 0;
                          const firstSlide = slides[0];
                          const secondSlide = slides[1];
                          if (!firstSlide || !secondSlide) return 0;
                          const firstRect = firstSlide.getBoundingClientRect();
                          const secondRect = secondSlide.getBoundingClientRect();
                          return secondRect.left - firstRect.left;
                        };
                        
                        const initFirstCustomAnimation = () => {
                          firstSlideDistance = calculateFirstSlideDistance();
                          firstCurrentPosition = 0;
                          firstWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                          firstWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
                        };
                        
                        const handleFirstNext = (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (firstSlideDistance === 0) firstSlideDistance = calculateFirstSlideDistance();
                          if (firstSlideDistance === 0) return;
                          const slides = firstWrapper.querySelectorAll('.swiper-slide');
                          const container = firstSwiper.querySelector('.swiper');
                          if (!container) return;
                          const containerWidth = container.clientWidth;
                          const visibleSlides = Math.floor(containerWidth / firstSlideDistance) || 1;
                          const maxPosition = -(slides.length - visibleSlides) * firstSlideDistance;
                          if (firstCurrentPosition <= maxPosition) return;
                          firstCurrentPosition -= firstSlideDistance;
                          firstWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                          firstWrapper.style.transform = `translate3d(${firstCurrentPosition}px, 0px, 0px)`;
                        };
                        
                        const handleFirstPrev = (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (firstSlideDistance === 0) firstSlideDistance = calculateFirstSlideDistance();
                          if (firstSlideDistance === 0) return;
                          if (firstCurrentPosition >= 0) return;
                          firstCurrentPosition += firstSlideDistance;
                          firstWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                          firstWrapper.style.transform = `translate3d(${firstCurrentPosition}px, 0px, 0px)`;
                        };
                        
                        const newFirstNextBtn = firstNextBtn.cloneNode(true);
                        firstNextBtn.parentNode.replaceChild(newFirstNextBtn, firstNextBtn);
                        const newFirstPrevBtn = firstPrevBtn.cloneNode(true);
                        firstPrevBtn.parentNode.replaceChild(newFirstPrevBtn, firstPrevBtn);
                        
                        newFirstNextBtn.addEventListener('click', handleFirstNext);
                        newFirstPrevBtn.addEventListener('click', handleFirstPrev);
                        
                        setTimeout(initFirstCustomAnimation, 100);
                      }
                      
                      // Fade in after reset and products have loaded
                      setTimeout(() => {
                        firstSwiper.classList.add('fade-in');
                        // Remove inline opacity to let CSS handle it
                        firstSwiper.style.opacity = '';
                      }, 250);
                    } catch (e) {
                      // Fallback: fade in even if there's an error
                      setTimeout(() => {
                        firstSwiper.classList.add('fade-in');
                        firstSwiper.style.opacity = '';
                      }, 250);
                    }
                    clearInterval(checkFirstSwiper);
              } else if (attempts >= 60) {
                // Fade in anyway after 3 seconds
                setTimeout(() => {
                  firstSwiper.classList.add('fade-in');
                  firstSwiper.style.opacity = '';
                }, 250);
                clearInterval(checkFirstSwiper);
              }
            }, 50);
          }
        }
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabbedProductCarousel);
  } else {
    initTabbedProductCarousel();
  }

  // Handle window resize to update indicator position and swiper positions
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      document.querySelectorAll('.tabbed-product-carousel_container__Ea4oS').forEach((section) => {
        // Update tab indicator position on resize
        const activeTab = section.querySelector('.tabbed-product-carousel_tab__d9wqz.tabbed-product-carousel_tab--active');
        if (activeTab && section._updateSelectedTabIndicator) {
          // Use the stored function reference
          section._updateSelectedTabIndicator(activeTab);
        }
        
        // Update swiper positions on resize handle both mobile and desktop transitions
        const activePanel = section.querySelector('.tabbed-product-carousel_panel__QbgFB.tabbed-product-carousel_panel--active');
        if (activePanel) {
          const swiper = activePanel.querySelector('product-swiper');
          if (swiper && swiper.swiper && swiper.swiper.initialized) {
            const currentIsMobile = window.innerWidth <= 900;
            const previousIsMobile = swiper._previousIsMobile !== undefined ? swiper._previousIsMobile : currentIsMobile;
            
            // Update swiper size and slides first
            swiper.swiper.updateSize();
            swiper.swiper.updateSlides();
            
            // If transitioning between mobile and desktop, need to reinitialize
            if (previousIsMobile !== currentIsMobile) {
              // Transitioning between modes need full reinitialization
              if (currentIsMobile) {
                // Transitioning to mobile
                const swiperWrapper = swiper.querySelector('.swiper-wrapper');
                if (swiperWrapper) {
                  // Clear desktop custom animation
                  swiperWrapper.style.removeProperty('transform');
                  swiperWrapper.style.removeProperty('transition');
                  
                  // Enable centeredSlides for mobile
                  if (swiper.swiper.params) {
                    swiper.swiper.params.centeredSlides = true;
                  }
                  
                  // Clear desktop properties
                  delete swiper._customPosition;
                  delete swiper._slideDistance;
                  
                  // Restore original setTranslate if it was overridden
                  if (swiper._originalSetTranslate && swiper.swiper.setTranslate) {
                    swiper.swiper.setTranslate = swiper._originalSetTranslate;
                    delete swiper._originalSetTranslate;
                  }
                  
                  // Reinitialize mobile centering
                  swiper.swiper.update();
                  swiper.swiper.slideTo(0, 0);
                  
                  // Use the mobile resize handler if available
                  if (swiper._mobileResizeHandler) {
                    swiper._mobileResizeHandler();
                  } else {
                    // Fallback: manually calculate centered position
                    requestAnimationFrame(() => {
                      requestAnimationFrame(() => {
                        const swiperContainer = swiper.querySelector('.swiper');
                        const firstSlide = swiperWrapper.querySelector('.swiper-slide');
                        if (swiperContainer && firstSlide && firstSlide.offsetWidth > 0) {
                          const containerWidth = swiperContainer.clientWidth;
                          const slideWidth = firstSlide.offsetWidth;
                          const centerOffset = (containerWidth - slideWidth) / 2;
                          const translateX = -centerOffset;
                          swiperWrapper.style.setProperty('transform', `translate3d(${translateX}px, 0px, 0px)`, 'important');
                          swiper._mobileCenteredPosition = translateX;
                        }
                      });
                    });
                  }
                }
              } else {
                // Transitioning to desktop
                const swiperWrapper = swiper.querySelector('.swiper-wrapper');
                if (swiperWrapper) {
                  // Remove mobile-specific styles
                  swiperWrapper.style.removeProperty('transform');
                  swiperWrapper.style.removeProperty('transition');
                  
                  // Disable centeredSlides for desktop
                  if (swiper.swiper.params) {
                    swiper.swiper.params.centeredSlides = false;
                  }
                  
                  // Reset Swiper's translate
                  swiper.swiper.setTranslate(0);
                  swiper.swiper.slideTo(0, 0);
                  
                  // Clear mobile-specific properties
                  delete swiper._mobileCenteredPosition;
                  if (swiper._mobileTransformObserver) {
                    swiper._mobileTransformObserver.disconnect();
                    delete swiper._mobileTransformObserver;
                  }
                  
                  // Restore original setTranslate if it was overridden
                  if (swiper._originalSetTranslate && swiper.swiper.setTranslate) {
                    swiper.swiper.setTranslate = swiper._originalSetTranslate;
                    delete swiper._originalSetTranslate;
                  }
                  
                  // Re-enable desktop custom animation
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      // Re-run setupCustomAnimation to initialize desktop behavior
                      const setupCustomAnimation = section._setupCustomAnimation;
                      if (setupCustomAnimation) {
                        // Call setupCustomAnimation to reinitialize desktop behavior
                        setupCustomAnimation(swiper);
                      } else {
                        // Fallback: manually set up desktop animation
                        if (swiper._slideDistance !== undefined) {
                          swiper._customPosition = 0;
                          swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                          swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
                        } else {
                          // If slide distance not set, need to recalculate
                          const slides = swiperWrapper.querySelectorAll('.swiper-slide');
                          if (slides.length >= 2) {
                            const firstSlide = slides[0];
                            const secondSlide = slides[1];
                            if (firstSlide && secondSlide) {
                              const firstRect = firstSlide.getBoundingClientRect();
                              const secondRect = secondSlide.getBoundingClientRect();
                              swiper._slideDistance = secondRect.left - firstRect.left;
                              swiper._customPosition = 0;
                              swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                              swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
                            }
                          }
                        }
                      }
                    });
                  });
                }
              }
              
              // Store current mode
              swiper._previousIsMobile = currentIsMobile;
            } else {
              // Same mode, just update position
              if (currentIsMobile) {
                // On mobile, recalculate centered position
                if (swiper._applyCenteredPosition) {
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      swiper._applyCenteredPosition();
                    });
                  });
                } else {
                  // Fallback: manually recalculate
                  const swiperWrapper = swiper.querySelector('.swiper-wrapper');
                  if (swiperWrapper) {
                    const swiperContainer = swiper.querySelector('.swiper');
                    if (swiperContainer) {
                      const firstSlide = swiperWrapper.querySelector('.swiper-slide');
                      if (firstSlide && firstSlide.offsetWidth > 0) {
                        const containerWidth = swiperContainer.clientWidth;
                        const slideWidth = firstSlide.offsetWidth;
                        const centerOffset = (containerWidth - slideWidth) / 2;
                        const translateX = -centerOffset;
                        swiperWrapper.style.setProperty('transform', `translate3d(${translateX}px, 0px, 0px)`, 'important');
                        swiper._mobileCenteredPosition = translateX;
                      }
                    }
                  }
                }
              } else {
                // On desktop, recalculate slide distance and update button states
                const swiperWrapper = swiper.querySelector('.swiper-wrapper');
                if (swiperWrapper && swiper._slideDistance !== undefined) {
                  // Recalculate slide distance
                  const slides = swiperWrapper.querySelectorAll('.swiper-slide');
                  if (slides.length >= 2) {
                    const firstSlide = slides[0];
                    const secondSlide = slides[1];
                    if (firstSlide && secondSlide) {
                      const firstRect = firstSlide.getBoundingClientRect();
                      const secondRect = secondSlide.getBoundingClientRect();
                      swiper._slideDistance = secondRect.left - firstRect.left;
                    }
                  }
                  
                  // Ensure position is valid
                  if (swiper._customPosition !== undefined) {
                    swiper._customPosition = Math.max(swiper._customPosition, 0);
                    swiperWrapper.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1)';
                    swiperWrapper.style.transform = `translate3d(${swiper._customPosition}px, 0px, 0px)`;
                  }
                }
              }
            }
          }
        }
      });
    }, 150); 
  });

  // Initialize selected tab indicators after initialization
  setTimeout(() => {
    document.querySelectorAll('.tabbed-product-carousel_container__Ea4oS').forEach((section) => {
      const activeTab = section.querySelector('.tabbed-product-carousel_tab__d9wqz.tabbed-product-carousel_tab--active');
      if (activeTab) {
        // Use the updateSelectedTabIndicator function
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
          
            const initIndicator = () => {
              const indicator = section.querySelector('.tabbed-product-carousel_selectedTab__P5f9M');
              const tabListContainer = section.querySelector('.tabbed-product-carousel_tabListContainer__B265N');
              
              if (indicator && tabListContainer && activeTab) {
                // Get gradient colors from data attributes
                let gradientStart = activeTab.getAttribute('data-gradient-start');
                let gradientEnd = activeTab.getAttribute('data-gradient-end');
                
                // Normalize values
                gradientStart = gradientStart ? gradientStart.trim() : '';
                gradientEnd = gradientEnd ? gradientEnd.trim() : '';
                
                // Fallback to defaults if nothing is set
                if (!gradientStart) gradientStart = '#3C39D7';
                if (!gradientEnd) gradientEnd = '#07ACD0';
                
                const gradient = `linear-gradient(90deg, ${gradientStart}, ${gradientEnd})`;
                
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    const tabRect = activeTab.getBoundingClientRect();
                    const containerRect = tabListContainer.getBoundingClientRect();
                    
                    // Calculate position: tab's viewport position - container's viewport position + scroll offset
                    const scrollLeft = tabListContainer.scrollLeft || 0;
                    const left = (tabRect.left - containerRect.left) + scrollLeft;
                    const top = tabRect.top - containerRect.top;
                    
                    indicator.style.background = gradient;
                    indicator.style.backgroundImage = gradient;
                    indicator.style.width = `${tabRect.width}px`;
                    indicator.style.height = `${tabRect.height}px`;
                    indicator.style.transform = `translate(${left}px, ${top}px)`;
                    indicator.style.opacity = '1';
                  });
                });
              } else if (indicator && tabListContainer) {
                // Retry if elements not ready
                setTimeout(initIndicator, 50);
              }
            };
            initIndicator();
          });
        });
      }
    });
  }, 100);

  // Handle Shopify theme editor events
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (section.classList.contains('tabbed-product-carousel_container__Ea4oS') || 
          section.querySelector('.tabbed-product-carousel_container__Ea4oS')) {
        initTabbedProductCarousel();
      }
    });

    document.addEventListener('shopify:block:select', (event) => {
      const sectionId = event.detail.sectionId;
      const section = document.getElementById(sectionId);
      const tabbedSection = section?.querySelector('.tabbed-product-carousel_container__Ea4oS') || section;

      if (tabbedSection && (tabbedSection.classList.contains('tabbed-product-carousel_container__Ea4oS') || 
          tabbedSection.querySelector('.tabbed-product-carousel_container__Ea4oS'))) {
        let tab = null;
        if (event.target.classList.contains('tabbed-product-carousel_tab__d9wqz')) {
          tab = event.target;
        } else {
          tab = event.target.closest('.tabbed-product-carousel_tab__d9wqz');
        }

        if (tab) {
          tab.click();
        }
      }
    });
  }
})();

